var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg822671B10C0B069F994Fe7F0109Ab602587852De(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 16 18.1333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88203 16.9322L11.4195 15.9523V12.2118L9.13982 10.7578L8.73692 10.5049L2.27965 6.41674V2.89754L0 4.34104V7.66004L0.190847 7.78648L2.27965 9.11408L6.45725 11.7587L7.45394 12.3804L8.24917 12.8862L8.62029 13.1285L8.73692 13.2022L9.13982 13.4551V14.7195L7.99469 15.436L0 10.3679V13.0547L2.27965 14.5088L5.87408 16.7847L7.99469 18.1333L9.13982 17.4063L9.88203 16.9322Z",
    fill: "url(#paint0_linear_2011_1678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55932 5.17343L6.84958 6.61693L9.13982 8.07097L11.4195 9.52501L13.7097 10.9685V14.5088L16 13.0547V4.35158L13.7097 2.89754V8.27116L11.4195 6.81712L9.13982 5.37362L6.84958 3.91958V0L4.55932 1.4435V5.17343Z",
    fill: "url(#paint1_linear_2011_1678)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2011_1678",
    x1: -4.60632e-7,
    y1: 18.1333,
    x2: 17.9922,
    y2: 2.25784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23E16E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2011_1678",
    x1: -4.60632e-7,
    y1: 18.1333,
    x2: 17.9922,
    y2: 2.25784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B14F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23E16E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg822671B10C0B069F994Fe7F0109Ab602587852De);
export default __webpack_public_path__ + "static/media/822671b10c0b069f994fe7f0109ab602587852de.89dada5ace18bafd1f688b786b42cde9.svg";
export { ForwardRef as ReactComponent };